module.exports = {
      id: "foursquare-usage",
      viewBox: "0 0 46 64",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#foursquare",
      toString: function () {
        return this.url;
      }
    }